import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";

import InstructorPoll from "./InstructorPoll";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  mainPage: (props) => ({
    zIndex: 0,
    marginLeft: props.userMenuOpen ? 260 : 0,
    marginRight: props.sessionMenuOpen ? 260 : 0,
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  }),
  noPollsText: {
    ...theme.typography.button,
    display: "flex",
    justifyContent: "center",
    paddingTop: "24px",
  },
});

function InstructorPolls(props) {
  const [persistentCategory, setPersistentCategory] = React.useState(null);
  const [persistentOptions, setPersistentOptions] = React.useState(null);

  const [globalCategory, setGlobalCategory] = React.useState(null);
  const [globalOptions, setGlobalOptions] = React.useState([]);

  let mobile = props.width === "sm" || props.width === "xs";

  return (
    <div className={mobile ? null : props.classes.mainPage}>
      <div className={props.classes.appBarSpacer} />

      {Object.keys(props.polls).length !== 0 ? null : (
        <Typography className={props.classes.noPollsText}>
          No polls in session
        </Typography>
      )}

      {
        /* mobile ? // Temporarily disabled swipeable views due to bugs
                    <SwipeableViews
                        index={Math.max(0, Object.keys(this.props.polls).length - 1)}
                    >
                        {Object.values(this.props.polls).map((poll, index) => {
                            return (
                                <InstructorPoll
                                    key={poll.pollID}
                                    index={index + 1}
                                    poll={poll}
                                    course={this.props.courses[this.props.match.params.courseID]}
                                />
                            )
                        })}
                    </SwipeableViews>
                    : */
        <Container maxWidth="md">
          {Object.values(props.polls)
            .reverse()
            .map((poll, i) => {
              if (i === 0) {
                return (
                  <InstructorPoll
                    key={poll.pollID}
                    poll={poll}
                    screenshotRender={props.screenshotRender}
                    screenshotEnabledDevice={props.screenshotEnabledDevice}
                    persistentCategory={persistentCategory}
                    persistentOptions={persistentOptions}
                    globalCategory={globalCategory}
                    globalOptions={globalOptions}
                    displayLive={props.displayLive}
                    pollActive={props.activePoll === poll.pollID}
                    setShowDisplayInactive={(show) =>
                      props.setShowDisplayInactive(show, poll.pollID)
                    }
                    setPersistentCategory={(cat) => setPersistentCategory(cat)}
                    setPersistentOptions={(opts) => setPersistentOptions(opts)}
                    setGlobalCategory={(cat) => setGlobalCategory(cat)}
                    setGlobalOptions={(opts) => setGlobalOptions(opts)}
                    deletePoll={props.deletePoll}
                    resumePoll={props.resumePoll}
                    sessionActive={props.sessionActive}
                    setAnswer={(answer) => props.setAnswer(poll.pollID, answer)}
                    unsetAnswer={() => {
                      props.setAnswer(poll.pollID, "");
                    }}
                    setLock = {()=>props.setLock(poll.pollID)}
                    setRender = {()=>{props.setRerender()}}
                    course={props.course}
                    userMenuOpen={props.userMenuOpen}
                    sessionMenuOpen={props.sessionMenuOpen}
                    driveInit={props.driveInit}
                  />
                );
              } else {
                return (
                  <InstructorPoll
                    key={poll.pollID}
                    poll={poll}
                    screenshotRender={props.screenshotRender}
                    screenshotEnabledDevice={props.screenshotEnabledDevice}
                    globalCategory={globalCategory}
                    globalOptions={globalOptions}
                    setPersistentCategory={(cat) => {}}
                    setPersistentOptions={(opts) => {}}
                    displayLive={props.displayLive}
                    pollActive={props.activePoll === poll.pollID}
                    setShowDisplayInactive={(show) =>
                      props.setShowDisplayInactive(show, poll.pollID)
                    }
                    setGlobalCategory={(cat) => setGlobalCategory(cat)}
                    setGlobalOptions={(opts) => setGlobalOptions(opts)}
                    deletePoll={props.deletePoll}
                    resumePoll={props.resumePoll}
                    sessionActive={props.sessionActive}
                    setAnswer={(answer) => props.setAnswer(poll.pollID, answer)}
                    unsetAnswer={() => {
                      props.setAnswer(poll.pollID, "");
                    }}
                    setLock = {()=>props.setLock(poll.pollID)}
                    setRender = {()=>{props.setRerender()}}
                    course={props.course}
                    userMenuOpen={props.userMenuOpen}
                    sessionMenuOpen={props.sessionMenuOpen}
                    driveInit={props.driveInit}
                  />
                );
              }
            })}
        </Container>
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorPolls))
  )
);
